import React from 'react'

import { PillarsListStyled, PillarsListItemStyled } from './styles'
import { PillarsListProps } from './types'
import Pillar from './../../molecules/Pillar'

const PillarsList: React.FC<PillarsListProps> = ({ list }) => {
  return (
    <PillarsListStyled>
      {list.map(({ key, title, icon, content }) => (
        <PillarsListItemStyled {...{ key }}>
          <Pillar {...{ title, icon, content }} />
        </PillarsListItemStyled>
      ))}
    </PillarsListStyled>
  )
}

export default PillarsList
